import { PaymentProviderAccountSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type PaymentProviderAccount = PaymentProviderAccountSchema;

/**
 * Get all connected payment providers for the organization
 */
export const getPaymentProviders = async (): Promise<PaymentProviderAccount[]> => {
  const response = await apiClient.get<{ accounts: PaymentProviderAccount[] }>("/api/payment-provider");
  return response.data.accounts;
};

/**
 * Get Stripe OAuth URL
 * Redirect user to this URL to connect Stripe
 */
export const getStripeOAuthUrl = async (redirect?: "settings" | "onboarding" | "dashboard"): Promise<string> => {
  const response = await apiClient.get<{ url: string }>("/api/payment-provider/stripe/auth", {
    params: redirect ? { redirect } : undefined,
  });
  return response.data.url;
};

/**
 * Get PayPal OAuth URL
 * Redirect user to this URL to connect PayPal
 */
export const getPayPalOAuthUrl = async (): Promise<string> => {
  const response = await apiClient.get<{ url: string }>("/api/payment-provider/paypal/auth");
  return response.data.url;
};

/**
 * Disconnect a payment provider
 */
export const disconnectPaymentProvider = async (accountId: string): Promise<void> => {
  await apiClient.delete(`/api/payment-provider/${accountId}`);
};

export default getPaymentProviders;
